import React, { Suspense, useMemo } from "react";

import OpportunityManagementTable from "@/opportunity/opportunity_table/OpportunityManagementTable";
import OpportunityManagementBoard from "@/opportunity/opportunity_table/OpportunityManagementBoard";
import { Spinner } from "@/components/ui/spinner";
import { Card } from "@/components/ui/card";
import { OpportunityAggregatedSavingsCard } from "@/opportunity/OpportunityAggregatedSavingsCard";
import { OpportunityManagementView, useOpportunityManagement } from "@/opportunity/OpportunityManagementContext";
import { useLocations } from "@/location/api";
import { useAllSnoozes } from "@/hooks/useSnooze";


const OpportunityManagementViewer = ({ organizationId }: { organizationId?: number }) => {

  const { view } = useOpportunityManagement();

  const { data: { results: locations } } = useLocations({
    filters: organizationId ? { organization_id: organizationId } : {},
  });
  const snoozedLocationIds = useMemo(
    () => new Set(locations.filter(l => l.is_snoozed).map(l => l.id)),
    [locations]
  );

  const { data: allSnoozes } = useAllSnoozes();
  const snoozedEquipmentIds = useMemo(
    () => new Set((allSnoozes ?? []).filter(s => s.equipment !== null).map(s => s.equipment!)),
    [allSnoozes]
  );

  return (
    <div className="flex flex-col gap-2">
      <OpportunityAggregatedSavingsCard/>
      <Card className="p-4 flex flex-col gap-2">
        <Suspense fallback={<Spinner/>}>
          {
            view === OpportunityManagementView.TABLE ? (
              <OpportunityManagementTable organizationId={organizationId} snoozedLocationIds={snoozedLocationIds} snoozedEquipmentIds={snoozedEquipmentIds}/>
            ) : (
              <OpportunityManagementBoard organizationId={organizationId} snoozedLocationIds={snoozedLocationIds} snoozedEquipmentIds={snoozedEquipmentIds}/>
            )
          }
        </Suspense>
      </Card>
    </div>
  );
};

export default OpportunityManagementViewer;